import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "aws-amplify/auth";
import "./App.css";

export default function WelcomePage({ user, onSignOut }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState("home");

  const handleSignOut = async () => {
    try {
      await signOut();
      onSignOut();
      navigate('/signin');
    } catch (err) {
      console.error("SignOut failed:", err);
    }
  };

  return (
    <div className="welcome-container">
      {/* Top navigation bar */}
      <div className="top-bar">
        <div className="top-left">
          <button onClick={() => handleSignOut()}>Sign Out</button>
        </div>
        <div className="header"><span>Bank of Mars</span></div>
        <div className="top-right">
          <button onClick={() => setCurrentPage("home")}>Home</button>
          <button onClick={() => setCurrentPage("account")}>Account</button>
        </div>
      </div>
  
      {/* Page content */}
      <div className="page-content">
        {currentPage === "home" && (
          <div className="home-page">
            <h2><span style={{ backgroundColor: 'white', padding: '0 8px', borderRadius: '4px' }}>Welcome to Bank of Mars</span></h2>
            <p><span style={{ backgroundColor: 'white', padding: '0 8px', borderRadius: '4px' }}>We're glad to have you here!</span></p>
          </div>
        )}
  
        {currentPage === "account" && (
          <div className="account-page">
            <h2>Your Account Details</h2>
            <p><strong>Username:</strong> {user.username}</p>
            <p><strong>Email:</strong> {user.email}</p>
            <p><strong>Phone:</strong> {user.phone}</p>
          </div>
        )}
      </div>
    </div>
  );
}